module.exports = __webpack_public_path__ + "static/media/advertise2.d838bc41.png";